import { createSelector, createSlice } from "@reduxjs/toolkit";

interface ImpersonationState {
  isVendorImpersonationSet: boolean;
  impersonatedUserEmail?: string;
  isImpersonationModalOpen: boolean;
  isImpersonationSessionExpired: boolean;
}

const initialState: ImpersonationState = {
  isVendorImpersonationSet: false,
  impersonatedUserEmail: undefined,
  isImpersonationModalOpen: false,
  isImpersonationSessionExpired: false,
};

export const impersonationSlice = createSlice({
  name: "impersonation",
  initialState,
  selectors: {
    GET_VENDOR_IMPERSONATION_STATE: createSelector(
      [(state) => state],
      (state) => {
        return {
          impersonation: {
            impersonatedUserEmail: state?.impersonatedUserEmail,
            isVendorImpersonationSet: state?.isVendorImpersonationSet,
            isImpersonationModalOpen: state?.isImpersonationModalOpen,
            isImpersonationSessionExpired: state?.isImpersonationSessionExpired,
          },
        };
      }
    ),
  },
  reducers: {
    SET_VENDOR_IMPERSONATION: (state, action) => {
      return {
        ...state,
        isVendorImpersonationSet: true,
        impersonatedUserEmail: action.payload,
        isImpersonationModalOpen: false,
        isImpersonationSessionExpired: false,
      };
    },
    OPEN_IMPERSONATION_MODAL: (state) => {
      return {
        ...state,
        isImpersonationModalOpen: true,
      };
    },
    CLOSE_IMPERSONATION_MODAL: (state) => {
      return {
        ...state,
        isImpersonationModalOpen: false,
      };
    },
    SET_IS_IMPERSONATION_SESSION_EXPIRED: (state) => {
      return {
        ...state,
        isVendorImpersonationSet: false,
        impersonatedUserEmail: undefined,
        isImpersonationSessionExpired: true,
      };
    },
    REMOVE_IMPERSONATION: (state) => {
      return {
        ...state,
        isVendorImpersonationSet: false,
        impersonatedUserEmail: undefined,
      };
    },
  },
});

export const {
  OPEN_IMPERSONATION_MODAL,
  CLOSE_IMPERSONATION_MODAL,
  SET_VENDOR_IMPERSONATION,
  SET_IS_IMPERSONATION_SESSION_EXPIRED,
  REMOVE_IMPERSONATION,
} = impersonationSlice.actions;
export const { GET_VENDOR_IMPERSONATION_STATE } = impersonationSlice.selectors;
export default impersonationSlice.reducer;
